import styled, { css } from 'styled-components'

const SelectPricePlanLabelUi = styled.div`
  margin-bottom: 15px;
  ${p => p.theme.phone} {
    justify-content: center;
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      justify-content: center;
    `}
`

export default SelectPricePlanLabelUi
